import { render, staticRenderFns } from "./ProductItemList.vue?vue&type=template&id=6d01407b&scoped=true&"
import script from "./ProductItemList.vue?vue&type=script&lang=js&"
export * from "./ProductItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01407b",
  null
  
)

export default component.exports